import Datetime from "components/shared/form/datetime";
import React from "react";
import { PANEL_CALENDAR_ID } from "./sidePanel";

/** Keep the popup outside the scroll body and inside the dialog's layer and focus boundary. */
export default function PanelDatetime(props) {
    return (
        <Datetime
            {...props}
            inPortal
            portalId={PANEL_CALENDAR_ID}
            libOptions={{
                ...props.libOptions,
                popperProps: { ...props.libOptions?.popperProps, strategy: "fixed" },
                enableTabLoop: false,
                disabledKeyboardNavigation: false,
            }}
        />
    );
}
